<template>

    <!-- Common Banner Area -->
    <RoomBanner />

    <!-- Room Details Areas -->
    <RoomDetails />




</template>
<script>
import RoomBanner from '@/components/hotel/RoomBanner.vue'
import RoomDetails from '@/components/hotel/RoomDetails.vue'

export default {
    name: "RoomDetailsView",
    components: {
        RoomBanner, RoomDetails
    }
};
</script>
